import { PluginSlugs } from '../../../config';

export const IntegrationTypes = {
    VAROSTEST: 'test_integ',
    FACEBOOK: 'facebookads',
    GOOGLE: 'google_ads',
    TIKTOK: 'tiktok_ads',
    SNAPCHAT: 'snapchat_ads',
    GOOGLE_ANALYTICS: 'google_analytics_v4',
    PINTEREST: 'pinterest_ads',
    LINKEDIN: 'linkedin_ads',
    TRADE_DESK: 'trade_desk',
    STRIPE: 'stripe',
    QUICKBOOKS: 'quickbooks',
    AMAZON: 'amazon_ads',
    SHOPIFY: 'shopify',
} as const;
